import { Location } from 'react-router-dom';
import { QuerySearchParameters } from "constants/url";
import { JSONObject } from "models/Api/types";

export function getSelectedTabFromURL(location: Location): number {
	const queryParams = new URLSearchParams(location.search);
	const tabIndex = queryParams.get(QuerySearchParameters.TAB);
	return tabIndex ? parseInt(tabIndex, 10) : 0;
};

export function getPageFromURL(location: Location): number {
	const queryParams = new URLSearchParams(location.search);
	const page = queryParams.get(QuerySearchParameters.PAGE);
	return page ? parseInt(page, 10) : 1;
};

export function getEligibleQueryParamsFromUrl(location: Location, eligibleQueryParams: QuerySearchParameters[] = []): JSONObject {
	const queryParams: JSONObject = {};
	const searchParams = new URLSearchParams(location.search);
	searchParams.forEach((value, key) => {
		if (eligibleQueryParams.length === 0 || eligibleQueryParams.includes(key as QuerySearchParameters)) {
			if (key === QuerySearchParameters.TAB || key === QuerySearchParameters.PAGE) {
				queryParams[key] = parseInt(value)
			} else {
				queryParams[key] = value;
			}
		}
	});

	return queryParams;
}

export function slugify(text: string) {
	return text
		.toString()
		.toLowerCase()
		.trim()
		.replace(/'/g, '')
		.replace(/[\s\W-]+/g, '-');
}

export function deslugify(slug: string) {
	return slug
		.replace(/-/g, ' ')
		.replace(/\b\w/g, l => l.toUpperCase());
}

export function getActiveRouteTitle(pathname: string): string | null {
	// Check for item detail route with slug/id pattern
	const itemMatch = pathname.match(/\/admin\/item\/([^/]+)\/([^/]+)/);
	if (itemMatch) {
		return deslugify(itemMatch[1]);
	}

	// Check for listing detail route with slug/id pattern
	const listingMatch = pathname.match(/\/admin\/listing\/([^/]+)\/([^/]+)/);
	if (listingMatch) {
		return deslugify(listingMatch[1]);
	}

	// Check for artist detail route with slug/id pattern
	const artistMatch = pathname.match(/\/admin\/artist\/([^/]+)\/([^/]+)/);
	if (artistMatch) {
		return deslugify(artistMatch[1]);
	}

	// Check for grouping detail route
	const groupingMatch = pathname.match(/\/admin\/groupings\/details\/([^/]+)/);
	if (groupingMatch) {
		return 'Grouping Details';
	}

	// Check for scrapejob detail route
	const scrapejobMatch = pathname.match(/\/admin\/scrapejobs\/details\/([^/]+)/);
	if (scrapejobMatch) {
		return 'Scrapejob Details';
	}

	return null;
}

export function findActiveRoute(pathname: string, routeList: RoutesType[]): RoutesType | null {
	for (const route of routeList) {
		const anyRoute = route;
		if (anyRoute.items) {
			const child = findActiveRoute(pathname, anyRoute.items);
			if (child) {
				return child;
			}
		}

		if (anyRoute.layout && anyRoute.path) {
			const fullPath = `${anyRoute.layout}${anyRoute.path}`.replace(/\\+/g, '/');
			const pattern = fullPath.replace(/:[^/]+/g, '[^/]+');
			const regex = new RegExp(`^${pattern}$`);
			if (regex.test(pathname)) {
				return route;
			}
		}
	}

	return null;
}
